__webpack_require__.p = "/hide-notifications/referrals/";